if (!customElements.get('serving-calculator')) {
  class ServingCalculator extends HTMLElement {
    constructor() {
      super();
      this.guests = 4;
      this.mealType = 'main';
    }

    connectedCallback() {
      this.slider = this.querySelector('[data-guests-slider]');
      this.guestDisplay = this.querySelector('[data-guest-count]');
      this.radios = this.querySelectorAll('[data-meal-radio]');
      this.resultsContainer = this.querySelector('[data-results]');
      this.explainer = this.querySelector('[data-explainer]');

      this.quantities = {
        prawns: {
          starter: parseFloat(this.dataset.prawnsStarter) || 150,
          main: parseFloat(this.dataset.prawnsMain) || 250,
          feast: parseFloat(this.dataset.prawnsFeast) || 350,
          bbq: parseFloat(this.dataset.prawnsBbq) || 300
        },
        fish: {
          starter: parseFloat(this.dataset.fishStarter) || 120,
          main: parseFloat(this.dataset.fishMain) || 200,
          feast: parseFloat(this.dataset.fishFeast) || 250,
          bbq: parseFloat(this.dataset.fishBbq) || 200
        },
        oysters: {
          starter: parseFloat(this.dataset.oystersStarter) || 3,
          main: parseFloat(this.dataset.oystersMain) || 6,
          feast: parseFloat(this.dataset.oystersFeast) || 12,
          bbq: parseFloat(this.dataset.oystersBbq) || 6
        },
        sashimi: {
          starter: parseFloat(this.dataset.sashimiStarter) || 80,
          main: parseFloat(this.dataset.sashimiMain) || 150,
          feast: parseFloat(this.dataset.sashimiFeast) || 200,
          bbq: parseFloat(this.dataset.sashimiBbq) || 100
        }
      };

      this.collectionUrls = {
        prawns: this.dataset.prawnsUrl || '/collections/prawns',
        fish: this.dataset.fishUrl || '/collections/fish',
        oysters: this.dataset.oystersUrl || '/collections/oysters',
        sashimi: this.dataset.sashimiUrl || '/collections/sashimi'
      };

      if (this.slider) {
        this.slider.addEventListener('input', (e) => {
          this.guests = parseInt(e.target.value, 10);
          this.guestDisplay.textContent = this.guests;
          this.calculate();
        });
      }

      this.radios.forEach((radio) => {
        radio.addEventListener('change', (e) => {
          this.mealType = e.target.value;
          this.calculate();
        });
      });

      this.calculate();
    }

    calculate() {
      var categories = ['prawns', 'fish', 'oysters', 'sashimi'];
      var labels = { prawns: 'Prawns', fish: 'Fish Fillets', oysters: 'Oysters', sashimi: 'Sashimi' };
      var icons = { prawns: '\uD83E\uDD90', fish: '\uD83D\uDC1F', oysters: '\uD83E\uDEA6', sashimi: '\uD83C\uDF63' };
      var mealLabels = { starter: 'Casual Starter', main: 'Main Course', feast: 'Seafood Feast', bbq: 'BBQ Spread' };

      if (!this.resultsContainer) return;

      var html = '';
      var firstExplainer = '';

      for (var i = 0; i < categories.length; i++) {
        var cat = categories[i];
        var perPerson = this.quantities[cat][this.mealType];
        var total = perPerson * this.guests;
        var display = '';
        var perPersonDisplay = '';

        if (cat === 'oysters') {
          var dozens = Math.ceil(total / 12);
          display = dozens === 1 ? '1 dozen' : dozens + ' dozen';
          perPersonDisplay = perPerson + ' per person';
        } else {
          if (total >= 1000) {
            display = (total / 1000).toFixed(1).replace(/\.0$/, '') + 'kg';
          } else {
            display = total + 'g';
          }
          perPersonDisplay = perPerson + 'g per person';
        }

        if (i === 0) {
          firstExplainer = 'We recommend ' + perPersonDisplay + ' of ' + labels[cat].toLowerCase() + ' for a ' + mealLabels[this.mealType].toLowerCase() + '.';
        }

        html += '<div class="serving-calculator__result-card">'
          + '<span class="serving-calculator__result-icon">' + icons[cat] + '</span>'
          + '<p class="serving-calculator__result-category">' + labels[cat] + '</p>'
          + '<p class="serving-calculator__result-amount">' + display + '</p>'
          + '<a href="' + this.collectionUrls[cat] + '" class="serving-calculator__result-link">Shop ' + labels[cat] + '</a>'
          + '</div>';
      }

      this.resultsContainer.innerHTML = html;

      if (this.explainer) {
        this.explainer.textContent = firstExplainer + ' Adjust the guest count and meal type to update recommendations.';
      }
    }
  }

  customElements.define('serving-calculator', ServingCalculator);
}
